import { Stack } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import { IconX, IconArrowsDiagonal2 } from "@tabler/icons-react";
import { LoadingSpinner } from "@/assets/icons";
import { usePlaygroundDispatch, usePlaygroundState } from "../usePlaygroundContext";
import { setPlaygroundPopoverOpen } from "../playgroundSlice";

interface GlobalPlaygroundStatusProps {
  onDismiss: () => void;
}

export const GlobalPlaygroundStatus = ({ onDismiss }: GlobalPlaygroundStatusProps) => {
  const dispatch = usePlaygroundDispatch();
  const { isPlaygroundPopoverOpen, currentSession } = usePlaygroundState();

  const chatStatus = currentSession?.chatStatus ?? "idle";

  const showStatus =
    !isPlaygroundPopoverOpen && ["pending", "complete", "error"].includes(chatStatus);

  const handleViewClick = () => {
    dispatch(setPlaygroundPopoverOpen(true));
  };

  if (!showStatus) {
    return null;
  }

  return (
    <Stack
      align="center"
      gap="sm"
      className="al-bg-bg-brand al-fixed al-bottom-20 al-right-6 al-z-[50] al-rounded-lg al-shadow-lg al-border al-border-gray-200 al-px-3 al-py-2"
    >
      {chatStatus === "pending" && (
        <>
          <LoadingSpinner className="al-w-4 al-h-4 al-text-blue-500 al-animate-spin" />
          <span className="al-text-sm al-text-gray-700">Processing...</span>
        </>
      )}
      {chatStatus === "complete" && (
        <>
          <span className="al-text-sm al-text-gray-700">Response ready!</span>
          <Button
            variant={"link"}
            onClick={handleViewClick}
            size="sm"
            className="al-text-sm al-text-blue-600 hover:al-text-blue-700 al-font-medium"
          >
            View
          </Button>
        </>
      )}
      {chatStatus === "error" && (
        <>
          <span className="al-text-sm al-text-gray-700">Unable to complete your request</span>
          <Button
            variant={"link"}
            onClick={handleViewClick}
            size="sm"
            className="al-text-sm al-text-blue-600 hover:al-text-blue-700 al-font-medium"
          >
            View
          </Button>
        </>
      )}
      <Stack align="center" gap="xs" className="al-ml-2 al-border-l al-border-gray-200 al-pl-2">
        <Button
          variant="ghost"
          size="icon"
          title="Maximize window"
          onClick={handleViewClick}
          aria-label={"Maximize window"}
          className="[&_svg]:al-size-5 al-w-8 al-h-8"
        >
          <IconArrowsDiagonal2 />
        </Button>
        <Button
          variant="ghost"
          size="icon"
          title="Close"
          onClick={onDismiss}
          aria-label={"Close"}
          className="[&_svg]:al-size-5 al-w-8 al-h-8"
        >
          <IconX />
        </Button>
      </Stack>
    </Stack>
  );
};
